<template>
  <layout-empty>
    <div class="onboarding_logo" :style="`width: ${width}px`">
      <div class="flex flex-centered mb-100">
        <img class="auth_logo--img" src="/images/forefront-logo.png" alt="Forefront">
      </div>

      <button-link
        v-if="includeBackButton"
        class="onboarding_logo--back"
        icon="chevron-left"
        @click="$emit('goBack')"
        size=""
      >Back</button-link>
    </div>

    <div :class="['onboarding_container', {'with_background': !noBackground}]" :style="`width: ${width}px`">
      <slot></slot>
    </div>
  </layout-empty>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "OnboardingContainer",
  props: {
    includeBackButton: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 700
    },
    noBackground: {
      type: Boolean,
      default: false,
    }
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.onboarding_container {
  position: relative;
  width: 700px;
  margin: 0 auto;
  padding: 1rem 2rem;

  &.with_background {
    background-color: $white;
  }
}

.onboarding_logo {
  position: relative;
  width: 700px;
  margin: 0 auto;

  &--back {
    position: absolute;
    top: 6px;
    left: 2rem;
  }
}
</style>
